module.exports = __webpack_public_path__ + "img/val2icon1.623a75a0.png";